import { useParams } from "react-router-dom";
import { useState } from "react";
import { Box, Paper, TextField, Typography } from "@mui/material";
import userService from "../../../../3_apps/5_Husibuech/HusibuechHelpers/2_Services/user.service";
import { TemplatePage } from "../../../0_TemplatePage/TemplatePage";
import KsbActionButton from "../../../components/KsbActionButton";
import { LockReset } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useTheme } from "@mui/material/styles";

export default function ResetPasswordPage() {
  const theme = useTheme();
  const { userId, token } = useParams();

  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (password !== repeat) {
      setError("Passwörter stimmen nicht überein");
      return;
    }

    try {
      await userService.resetPassword(userId, token, password);
      setSuccess(true);
    } catch (e) {
      setError("Link ungültig oder abgelaufen");
    }
  };

  return (
    <TemplatePage type="default">
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Paper
          elevation={5}
          sx={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 3,
            p: 4,
            textAlign: "center",
          }}
        >
          {!success ? (
            <>
              <Typography variant="h5" gutterBottom>
                Neues Passwort
              </Typography>

              <TextField
                fullWidth
                type="password"
                label="Passwort"
                autoComplete="new-password"
                sx={{ mt: 3 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <TextField
                fullWidth
                type="password"
                label="Passwort wiederholen"
                autoComplete="new-password"
                sx={{ mt: 2 }}
                value={repeat}
                onChange={(e) => setRepeat(e.target.value)}
              />

              {error && (
                <Typography color="error" sx={{ mt: 1 }}>
                  {error}
                </Typography>
              )}

              <KsbActionButton
                onClick={handleSubmit}
                icon={<LockReset />}
                label="Passwort zurücksetzen"
                sx={{
                  mt: 2,
                  bgcolor: theme.palette.primary.main,
                  "&:hover": { bgcolor: theme.palette.primary.dark },
                }}
              />
            </>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                ✅ Passwort geändert
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Du kannst dich jetzt mit deinem neuen Passwort anmelden.
              </Typography>

              <KsbActionButton
                onClick={() => (window.location.href = "/")}
                icon={<ArrowBackIcon />}
                label="Zum Login"
                sx={{
                  mt: 2,
                  bgcolor: theme.palette.primary.main,
                  "&:hover": { bgcolor: theme.palette.primary.dark },
                }}
              />
            </>
          )}
        </Paper>
      </Box>
    </TemplatePage>
  );
}
